import ApplicationComponent from "legacy/ApplicationComponent"
import { buildRoute } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

import Modal from "src/components/Modal"

class SaleCancelModal extends ApplicationComponent {
  constructor(args) {
    super(args)
    this.state = {
      showModal: false,
      isLoading: false,
      error: null,
    }

    this.handleOpenModal = this.handleOpenModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.postCancelSale = this.postCancelSale.bind(this)
  }

  handleOpenModal() {
    this.setState({ showModal: true })
  }

  handleCloseModal() {
    if (this.state.showModal) {
      this.setState({ showModal: false, error: null })
    }
  }

  postCancelSale() {
    this.setState({ isLoading: true })
    // Note: jQuery ($) is loaded globally
    $.ajax({
      url: buildRoute($context.cancelSalePath, { sale_id: this.props.sale.id }),
      type: "POST",
      dataType: "json",
      contentType: "application/json",
      success: (data) => {
        // Note: Amplitude is loaded globally
        Amplitude.trackEvent("web_pos:cancel_pressed", {
          sale_id: this.props.sale.id,
        })
        this.setState({ isLoading: false })
        this.props.handleProcessing(data.responseJSON)
        this.handleCloseModal()
      },
      error: (data) => {
        this.setState({ isLoading: false })
        this.setState({ error: data.responseJSON.error })
      },
    })
  }

  render() {
    return (
      <div>
        <div className="m-0">
          <button
            type="button"
            className="btn btn-secondary mr-1 w-14"
            onClick={this.handleOpenModal}
          >
            Cancel
          </button>
        </div>
        <Modal
          isOpen={this.state.showModal}
          onClose={this.handleCloseModal}
          size="mediumFixed"
        >
          <Modal.Header title="Confirm cancellation" />
          <Modal.Body>
            <div className="flex-col">
              <p>
                Would you like to cancel this sale? You will not be able to
                accept payment for this sale and will need to create a new sale
                to proceed.
              </p>
              {this.state.error && (
                <p className="text-danger font-bold">{this.state.error}</p>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer
            cancelBtnText="Nevermind"
            confirmBtnText="Yes, cancel this sale"
            confirmBtnLoading={this.state.isLoading}
            confirmBtnVariant="danger"
            onClose={this.handleCloseModal}
            onSubmit={this.postCancelSale}
          />
        </Modal>
      </div>
    )
  }
}

SaleCancelModal.propTypes = {
  sale: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  handleProcessing: PropTypes.func.isRequired,
}

export default SaleCancelModal
